import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FileManagerService, FileManagerTipologieService, PrinterService } from '../../../api/services';
import { printerModelActions } from './printer-model.actions';
import { delay, exhaustMap } from 'rxjs';
import { mapResponse } from '@ngrx/operators';
import { LoadingState } from '../models/loader.model';

export const printerModelEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerModelActions.loadPrinterModel),
      exhaustMap((props) =>
        compService.printerControllerFindAllPrinterModel({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerModelActions.loadPrinterModelDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerModelActions.loadPrinterModelDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: "Impossibile recuperare l'elenco dei modelli." },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const printerModelOneEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerModelActions.loadOnePrinterModel),
      exhaustMap((props) =>
        compService.printerControllerFindOnePrinterModel({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerModelActions.loadOnePrinterModelDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerModelActions.loadOnePrinterModelDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile recuperare il modello selezionato.' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const updatePrinterModelEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerModelActions.updateModel),
      exhaustMap((props) =>
        compService.printerControllerUpdatePrinterModel({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => printerModelActions.updateModelDone({ data: r.data!, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerModelActions.updateModelDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile modificare l/etichetta' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const mediaTypeEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(FileManagerTipologieService)) => {
    return actions$.pipe(
      ofType(printerModelActions.loadFileTypes),
      exhaustMap((props) =>
        compService.mediaTypeControllerFindAll({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerModelActions.loadFileTypesDone({ data: r.data!, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              printerModelActions.loadFileTypesDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile recuperare i files' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
export const loadPrintersCountByModelEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(printerModelActions.loadPrintersCountByModel),
      exhaustMap((props) =>
        compService.printerControllerPrinterModelFleetSummary({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              printerModelActions.loadPrintersCountByModelDone({
                data: r.data!,
                state: { value: LoadingState.SUCCESS },
              }),
            error: (error: { message: string }) =>
              printerModelActions.loadPrintersCountByModelDone({
                state: {
                  value: LoadingState.FAIL,
                  message: {
                    severity: 'warn',
                    text: 'Impossibile recuperare il conteggio dei dispositivi per modello',
                  },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
